<template>
<div class="odr-block__wrap odr-block__wrap_with-bottom-space">
    <main-button type="button"
                 :data-qa="dataQa"
                 :data-qa-recorder="dataQaRecorder"
                 @click="submit">
        <icon color="plain" half-width="true">keyboard_arrow_left</icon>
        <text-regular :color="color" bold="true">
            <slot/>
        </text-regular>
    </main-button>
</div>
</template>

<script>
import '@/scss/blocks/block.scss';

export default {
    props: {
        dataQa: {},
        color: {
            type: String,
            default: 'plain',
        },
        submit: {}, // dont use type="submit" to avoid double submit
        dataQaRecorder: {},
    },
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        'text-regular': require('@clearwave/odoro-markup/lib/vue/text-regular.vue').default,
        'main-button': require('@clearwave/odoro-markup/lib/vue/main-button.vue').default,
    },
};

</script>
